import { render, staticRenderFns } from "./storeBox.vue?vue&type=template&id=c2c429fe&scoped=true&"
import script from "./storeBox.vue?vue&type=script&lang=js&"
export * from "./storeBox.vue?vue&type=script&lang=js&"
import style0 from "./storeBox.vue?vue&type=style&index=0&id=c2c429fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c429fe",
  null
  
)

export default component.exports